import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=3a501786&scoped=true&"
import script from "./CollectionView.vue?vue&type=script&lang=js&"
export * from "./CollectionView.vue?vue&type=script&lang=js&"
import style0 from "./CollectionView.vue?vue&type=style&index=0&id=3a501786&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a501786",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
